export const BgColors = {
    bgColors: {
      bgPrimary0: "#FFFFFF",
      bgPrimary100: "#FFFFFF",
      bgPrimary200: "#e3e3e3",
      bgPrimary300: "#E0E0E0",
      bgPrimary400: "#888888",
      bgPrimary500: "#CCCCCC",
      bgPrimary600: "#E0E0E0",
      bgPrimary900: "#999999",
      bgPrimary1000: "#000000",
      bgRadial: "#e2e1e1",
      bgCockpitBar: "#535353",
      bgClixBar: "#e2e1e1",
      bgInitial0: "#000000",
      bgStatusError: "#000000",
      bgStatusTrue: "#3EAA1B",
      bgStatusInfo: "#415C98",
      bgDeleteBtn: "#BBBBBB",
      bgPlayBtn: "#BBBBBB",
      bgEditBtn: "#BBBBBB",
      bgSwitchOn: "#080606",
      bgSwitchOff: "#807e7e",
      bgDnd: "#F0F0F0",
      bgModal: "#e3e3e3",
      bgModalError: "#F0F0F0",
      bgModalSuccess: "#F0F0F0",
      bgModalWarning: "#F0F0F0",
      bgMenu: "#585858",

      bgBoxes: "#FFFFFF",
      bgPlainBtn: "#FFFFFF",
      bgBar: "#F0F0F0",
      bgMuted: "#F0F0F0",
      bgAiBtn: "#757575",
      bgAiBtnSelected: "#000000",
      bgAiBtnHover: "#545454",
      bgFilter: "#FFFFFF",
      bgLoginService: "#222222",
  
      bgProgress20:  "#BBBBBB",
      bgProgress40:  "#080606",
      bgProgress60:  "#777777",
      bgProgress80:  "#555555",
      bgProgress100: "#222222",
      bgToastProgress: "#222222",
      bgProgress120: "#000000",
      bgContrastProgress: "#222222",

      bgProgressHover: "#45474a",
      bgCircle:"#FFFFFF",
      bgAnalyseButton:"#000000",
      bgAnalyseBtnActive: "#222222",
      bgAnalyseTop: "#FFFFFF",
      bgAnalyseCenterC: "#000000",
      bgAnalyseCenter: "#FFFFFF",
      
      bgBlue50: "#FFFFFF",
      bgBlue100: "#F0F0F0",
      bgBlue150: "#FFFFFF",
      bgBlue200: "#FFFFFF",
      bgBlue300: "#757575",
      bgBlue1000: "#FFFFFF",
      bgYellow1000: "#080606",
  
      bgLightGreen: "#90EE90",
      bgLightYellow: "#999999",
      bgLightPink: "#D6D6D6",
      bgDanger:"#000000"
    },
  };